import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import LazyLoopClip from "../LazyLoopClip";

const CLIPS = [
  {
    id: "clip-01",
    src: "/videos/bluepath-robotics-amr-demo.mp4",
    poster: "/images/bluepath-robotics-amr-demo.jpg",
    label: "Robots arriving in the MAG Lab",
    width: 1280,
    height: 720,
  },
  {
    id: "clip-02",
    src: "/videos/linkedin-video-758kbps.mp4",
    poster: "/images/mag-lab-mixed-fleet.jpg",
    label: "MAG Lab integration footage",
    width: 1280,
    height: 720,
  },
  {
    id: "clip-03",
    src: "/videos/linkedin-video-570kbps.mp4",
    poster: "/images/mag-lab-validation.jpg",
    label: "MAG Lab validation footage",
    width: 1280,
    height: 720,
  },
];

export default function HomeMagLab() {
  return (
    <section className="bg-gray-950 text-white" aria-labelledby="lab-heading">
      <div className="flex flex-col gap-2 pb-2">
        <div className="px-4 pb-8 pt-16 sm:px-8 sm:pb-10 sm:pt-20 lg:px-12">
          <Reveal className="max-w-3xl">
            <h2 id="lab-heading" className="text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
              MAG Lab
            </h2>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg">
              In Metro Detroit, every process is tested, proven, and demoed in the Lab before
              it ships to a customer floor.
            </p>
            <Link to="/mag-lab" className="btn-primary mt-8">
              Visit the MAG Lab
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
          {CLIPS.map((clip) => (
            <LazyLoopClip
              key={clip.id}
              src={clip.src}
              poster={clip.poster}
              label={clip.label}
              width={clip.width}
              height={clip.height}
              wrapperClassName="relative min-h-[16rem] overflow-hidden bg-black sm:min-h-[22rem] lg:min-h-[32rem] xl:min-h-[36rem]"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
